module.exports = __webpack_public_path__ + "img/nichole.ec115d6c.jpg";